import * as yup from 'yup';
import { emailRegex, phoneRegex, urlRegex, zipCode } from '../../../regex';

export default yup.object().shape({
  address: yup.string().required().label('Address'),
city: yup.string().required().label('City'),
  boNumber: yup.string().required().label('B O Number'),
  boName: yup.string().required().label('B O Name'),
  boEmail: yup.string().matches(emailRegex, 'Enter a valid email address').required().label('Email '),
  zipCode: yup
    .string()
    .matches(zipCode, 'Invalid Code number. The code number must be in format 55555 or 55555-5555')
    .required()
    .label('Zip Code'),
});

export const ContactSchema = yup.object().shape({
  contactName: yup.string().required().label('Contact Name'),
  contactType: yup.string().required().label('Contact Type'),
  email: yup.string().matches(emailRegex, 'Enter a valid email address').required().label('Email '),
  phone: yup
    .string()
    .matches(phoneRegex, { message: 'Invalid phone number. The phone number must be in format 2XX-XXX-XXXX', excludeEmptyString: true })
    .label('Phone'),
});

export const LinkSchema = yup.object().shape({
  link: yup.string().required().label('Link').matches(urlRegex, "Enter a valid url starts with http:// or https://"),
  description: yup.string().required().label('Description'),
});
